import type { FC } from "react";
import Box from "@mui/material/Box";
import type { TranslationKey } from "@privacy/translations";
import { useTranslation } from "@privacy/translations";
import type { Agreement } from "../../api/partners";

export const getSystemIdsWithAgreementSelected = (agreements: Agreement[]) =>
  new Set(agreements.flatMap(agreement => agreement.selectedOnSystemIds ?? []));

type AgreementUsageNoteProps = {
  count: number;
  oneKey: TranslationKey;
  manyKey: TranslationKey;
};

export const AgreementUsageNote: FC<AgreementUsageNoteProps> = ({ count, oneKey, manyKey }) => {
  const { t } = useTranslation();
  if (count === 0) return null;
  return (
    <Box component="span" sx={{ display: "block", mt: 1 }}>
      {t(count === 1 ? oneKey : manyKey, { count })}
    </Box>
  );
};
